import { ReactComponent as SearchIcon } from 'assets/search.svg'
import AutocompleteInput from 'components/shared/textFields/AutocompleteInput'
import { useFilterToggle } from 'hook/useFilterToggle'
import { useEffect } from 'react'
import { fetchDiagnosesList } from 'store/cattlesSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

type DiagnoseContentBlockProps = {
	setActiveFilters: React.Dispatch<React.SetStateAction<any>>
	diagnoses: { ids: number[] }
}

const DiagnoseContentBlock = (props: DiagnoseContentBlockProps) => {
	const { setActiveFilters, diagnoses = { ids: [] } } = props
	const dispatch = useAppDispatch()
	const { diagnosesList, diagnosesListPending, diagnosesListError } =
		useAppSelector(state => state.cattlesSlice)

	const handleDiagnosesToggle = useFilterToggle(
		'diagnoses.ids',
		diagnosesList,
		setActiveFilters,
	)

	useEffect(() => {
		if (diagnosesList.length === 0) {
			dispatch(fetchDiagnosesList())
		}
	}, [])

	return (
		<>
			{diagnosesListError ? (
				<TypographyPrimary>{diagnosesListError}</TypographyPrimary>
			) : (
				<AutocompleteInput
					startIcon={<SearchIcon stroke={COLORS.icon} />}
					widthForInput={'100%'}
					onClick={handleDiagnosesToggle}
					isCheckbox
					availableList={diagnosesList}
					loading={diagnosesListPending}
					selectedValues={diagnoses.ids}
					label={'Диагнозы'}
					limitTags={2}
					needChip
				/>
			)}
		</>
	)
}

export default DiagnoseContentBlock
